import * as React from 'react';
import { themeGet } from 'styled-system';
import styled from 'styled-components';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { FieldProps } from 'formik';

interface CheckboxProps {
  label: string;
  onChange: Function;
}

const InputWrap = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding: 20px;
  position: relative;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
  box-sizing: border-box;
  cursor: pointer;
  justify-content: center;
  border: 1px solid ${themeGet('colors.paleGrey', '#eee')};
  & input[type='checkbox'] {
    position: absolute;
    left: 20px;
    width: 15px;
    height: 15px;
    z-index: 5;
    border-radius: 4px;
    transition: border 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: 2px solid ${themeGet('colors.transparentBlack', '#eee')};
  }
  & input[type='checkbox']:checked {
    border: 2px solid ${themeGet('colors.putty', '#eee')};
    background: ${themeGet('colors.putty', '#eee')};
  }
  & input[type='checkbox']:checked ~ label {
    color: ${themeGet('colors.putty', '#eee')};
    border: 1px solid ${themeGet('colors.putty', '#eee')};
  }
  &:hover label {
    color: ${themeGet('colors.putty', '#eee')};
  }
  &:hover input[type='checkbox'] {
    border: 2px solid ${themeGet('colors.putty', '#eee')};
    cursor: pointer;
  }
  @media screen and (max-width: 1440px) {
    flex: 1 0 31%;
    margin-right: 20px;
  }
  @media screen and (max-width: 1024px) {
    flex: 1 0 47%;
    margin-right: 20px;
  }
  @media screen and (max-width: 768px) {
    flex: 1 0 100%;
    margin-right: 0;
  }
`;

const RadioLabel = styled.label`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  border-radius: 4px;
  position: absolute;
  align-items: center;
  font-weight: normal;
  justify-content: center;
  text-transform: uppercase;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[2]};
`;

const InputFeedback = ({ error }: { error: string }) => (error ? <div>{error}</div> : null);

const Checkbox: React.FunctionComponent<CheckboxProps & FieldProps> = ({
  form,
  label,
  field,
  onChange
}) => {
  return (
    <InputWrap>
      <input
        name={field.name}
        id={field.name}
        type="checkbox"
        value={field.value}
        checked={field.value}
        onChange={val => {
          form.setFieldValue(field.name, val);
          if (onChange) {
            onChange(val);
          }
        }}
        onBlur={field.onBlur}
        disabled={false}
      />
      <RadioLabel htmlFor={field.name}>{label}</RadioLabel>
      <div className="check" />
      {form.touched[name] && <InputFeedback error={''} />}
    </InputWrap>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledCheckbox.tsx